import { GET_INPUT_VALIDATION_CLEAR, GET_INPUT_VALIDATION_ONBLUR } from "constants/actionTypes";
import { inputValidationType } from "type/productValidation";

const inputValidation=(payload:inputValidationType) => {
  const {eventType, fieldId, value,rowIndex} = payload;
  if(eventType==='blur'){
    return {
      type: GET_INPUT_VALIDATION_ONBLUR,
      payload: {
        eventType,
        fieldId,
        value,
        rowIndex,
      },
    };
  }
  return {
    type: GET_INPUT_VALIDATION_CLEAR,
    payload: {
      eventType: '',
      fieldId: '',
      value: '',
    },
  };
};

export default inputValidation;